import { Carousel } from 'react-bootstrap'

import ImageElement from './ImageElement'

const CarouselElement = ({data}) => {
  return (
    <Carousel indicators={false} className='slider'>
      {data.images.map((element, index) => (
        <Carousel.Item key={index}>
          <ImageElement content={element.content} title={element.title} aspectRatio={element.aspectRatio} />
        </Carousel.Item>
      ))}
    </Carousel>
  )
}

export default CarouselElement